import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core'

@Directive({
  selector: '[mgEnterElementViewport]',
  standalone: false
})
export class EnterElementViewportDirective implements AfterViewInit, OnDestroy {
  @Output() visibilityChange = new EventEmitter<boolean>()
  private _observer: IntersectionObserver
  private _isIntersecting = false

  constructor(private _elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.0 // Trigger as soon as any part of the element enters the viewport
    }
    this._observer = new IntersectionObserver(this._callback, options)
    this._observer.observe(this._elementRef.nativeElement)
  }

  ngOnDestroy() {
    if (this._observer) {
      this._observer.disconnect()
    }
  }

  private _callback = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      const isIntersecting = entry.isIntersecting

      // Only emit if the intersection state has actually changed
      if (this._isIntersecting !== isIntersecting) {
        this._isIntersecting = isIntersecting
        this.visibilityChange.emit(isIntersecting)
      }
    })
  }
}
